export default {
  methods: {
    toUpperCaseGeneral(obj, field) {
  // Si se pasa un string directamente
      if (typeof obj === 'string') {
        return obj
          .toUpperCase()
          .trim()
          .replace(/\s+/g, ' ');
      }

      // Si se pasa un objeto con campo
      if (obj && field && typeof obj[field] === 'string') {
        obj[field] = obj[field]
          .toUpperCase()
          .trim()
          .replace(/\s+/g, ' ');
      }

      return obj;
      }
    }
  }